import { Questions } from '../../constants/apis';
import type { AnswerChild, FeedbackShare, FeedbackTopicType, QuestionParent } from '../../types/feedbacks';
import { ApiManager } from '../axios-config';

export const createQuestion = async (
  topicId: QuestionParent['topicId'],
  topicType: FeedbackTopicType,
  content: QuestionParent['content'],
  ranges: FeedbackShare['ranges'],
  mentions: FeedbackShare['mentions'],
  token: string,
  topicSlug: string,
  topicTitle: string,
) => {
  return ApiManager.post(
    `${Questions}`,
    {
      topicId,
      topicType,
      content,
      topicSlug,
      topicTitle,
      ranges,
      mentions,
    },
    { headers: { Authorization: `Bearer ${token}` } },
  );
};

export const createAnswerQuestion = async (
  questionId: AnswerChild['questionId'],
  topicId: QuestionParent['topicId'],
  topicType: QuestionParent['topicType'],
  content: QuestionParent['content'],
  ranges: FeedbackShare['ranges'],
  mentions: FeedbackShare['mentions'],
  token: string,
  topicSlug: string,
  topicTitle: string,
) => {
  return ApiManager.post(
    `${Questions}/${questionId}/answer`,
    {
      topicId,
      topicType,
      content,
      topicSlug,
      topicTitle,
      ranges,
      mentions,
    },
    { headers: { Authorization: `Bearer ${token}` } },
  );
};

export const updateQuestion = async (
  questionId: AnswerChild['questionId'],
  content: QuestionParent['content'],
  ranges: FeedbackShare['ranges'],
  mentions: FeedbackShare['mentions'],
  token: string,
) => {
  return ApiManager.put(
    `${Questions}/${questionId}`,
    {
      content,
      ranges,
      mentions,
    },
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
};

export const trashQuestion = async (questionId: QuestionParent['id'], token: string) => {
  return ApiManager.put(
    `${Questions}/trash`,
    { ids: [questionId] },
    { headers: { Authorization: `Bearer ${token}` } },
  );
};

export const setBestAnswer = async (
  questionId: AnswerChild['questionId'],
  answerId: AnswerChild['id'],
  token: string,
) => {
  return ApiManager.put(
    `${Questions}/${questionId}/best-answer/set`,
    {
      bestAnswerId: answerId,
    },
    { headers: { Authorization: `Bearer ${token}` } },
  );
};

export const unsetBestAnswer = async (questionId: AnswerChild['questionId'], token: string) => {
  return ApiManager.put(
    `${Questions}/${questionId}/best-answer/unset`,
    {},
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
};
